/** What can take keyboard focus inside a dialog. */
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function focusables(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter((el) => !el.hasAttribute('aria-hidden'));
}

export function firstFocusable(root: HTMLElement): HTMLElement | null {
  // The close button comes first in the markup; start on the content instead when there is any.
  const all = focusables(root);
  return all.find((el) => el.getAttribute('aria-label') !== 'Cerrar') ?? all[0] ?? null;
}

/** Keeps Tab and Shift+Tab cycling inside `root`. */
export function trapTab(event: KeyboardEvent, root: HTMLElement): void {
  const all = focusables(root);
  if (all.length === 0) {
    event.preventDefault();
    return;
  }
  const first = all[0];
  const last = all[all.length - 1];
  const active = document.activeElement;
  if (event.shiftKey && (active === first || !root.contains(active))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (active === last || !root.contains(active))) {
    event.preventDefault();
    first.focus();
  }
}
